import React, {useState} from 'react';
import Customer from '../../../types/Customer';
import Button from '../../button';

interface Props {
  customer: Customer;
}

const AdminUserSendPasswordResetForm: React.FC<Props> = ({ customer }) => {
  const [message, setMessage] = useState('');
  const [error, setError] = useState(false);
  const [disabled, setDisabled] = useState(false);

  const onClick = async (e) => {
    setMessage('');
    setError(false);
    setDisabled(true);

    e.preventDefault();

    const bodyData = new URLSearchParams();
    bodyData.append('username', customer.username);

    const res = await fetch('/api/forgot-password', {
      method: 'post',
      body: bodyData.toString(),
    });

    if (res.ok) {
      setMessage('Password reset sent.');
      setDisabled(false);
    } else {
      setError(true);
      setMessage('Password reset failed to send.');
      setDisabled(false);
    }
  };

  return (
    <form onSubmit={(e) => {
      e.preventDefault();
    }}>
      <h2>Send Password Reset</h2>
      {message && <p className={error ? "error" : ""}>{message}</p>}
      <Button text="Send" onClick={onClick} disabled={disabled}/>
      {/* language=CSS */}
      <style jsx>{`
        .error {
          color: red;
        }
      `}</style>
    </form>
  );
};

export default AdminUserSendPasswordResetForm;
